// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab_tab__20o3o","tab_active":"tab_tab_active__6k1Vb"};